module.exports = __webpack_public_path__ + "img/audi-logo.9e750630.svg";